import { render, staticRenderFns } from "./WorkplaceDetail.vue?vue&type=template&id=176e7371&scoped=true"
import script from "./WorkplaceDetail.vue?vue&type=script&lang=js"
export * from "./WorkplaceDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkplaceDetail.vue?vue&type=style&index=0&id=176e7371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e7371",
  null
  
)

export default component.exports